import { Button, Grid } from "@mui/material";
import * as React from "react";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { differenceInDays } from "date-fns";
import { useContext, useEffect, useRef, useState } from "react";
import axios from "../../axiosInstances";
import { ShoppingCartContext } from "../Context/ShoppingCartContext";
import SignupModel from "./SignupModel";
function LogInModel(props) {
    const { t, i18n } = useTranslation();
  const userRef = useRef();
  const errRef = useRef();
  const {
    setGlobalUser,
    setGlobalProviders,
    setGlobalCustomers,
    setAllItems,
    setGlobalRoleSecurity,
    setGlobalStores,
    setGlobalToken,
    setGlobalSetting,
  } = useContext(ShoppingCartContext);
  let history = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setpassword] = useState("");
  const [errMsg, seterrMsg] = useState("");
  const [success, setsuccess] = useState(false);

  useEffect(() => {
    setOpen(true);
    seterrMsg("");
  }, [userName, password]);
  const loadParent = (parent, role, store, token) => {

    try {
      axios
        .get(
          "/suppliers/getParentAndProviders?Parent=" +
          parent +
          "&Role=" +
          role +
          "&Store=" +
          store,
          {
            headers: {
              token: token,
            },
          }
        )
        .then((result) => {
          setGlobalProviders(result.data.data.Providers);
          setGlobalCustomers(result.data.data.Customers);
          setAllItems(result.data.data.Products);
          setGlobalRoleSecurity(result.data.data.Roles);
          setGlobalStores(result.data.data.Stores);
          setGlobalSetting(result.data.data.SystemSettings);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handleSummit = async (e) => {
    e.preventDefault();
    try {
      var formdata = new FormData();
      formdata.append("UserName", document.getElementById("username").value);
      formdata.append("Password", document.getElementById("password").value);

      const response = await axios.post("/employees/ByUserName", formdata, {
        headers: { "Content-Type": "application/json" }
      })
      if (response.data) {

        const accessorToken = response.data;

        //sessionStorage.setItem("accessorToken", accessorToken.token)

        if (!accessorToken.CurrentUser.LicenseStartDate) {
          alert("Your company have license issue");
          seterrMsg("Your company have license issue");
          return;
        }
        else if (differenceInDays(new Date(accessorToken.CurrentUser.LicenseEndDate), new Date()) <= -30) {

          alert("Your company license is expired..Please contact with EthioB2B for renewal.");
          seterrMsg("Your company license is expired..Please contact with EthioB2B for renewal.");
          return;
        }
        else if (!accessorToken.CurrentUser.LicenseEndDate) {
          alert("Your License has been expired. Please contact with EthioB2B for renewal.");
          seterrMsg("Your License has been expired.Please contact with EthioB2B for renewal.");
          return;
        }
        else if (differenceInDays(new Date(accessorToken.CurrentUser.LicenseEndDate), new Date()) < 0) {
          alert("Your License is expired only few days are given. Please communicate with EthioB2B for renewal.");
          seterrMsg("Your License is expired. Only few days are given.");
        }
        else if (differenceInDays(new Date(accessorToken.CurrentUser.LicenseEndDate), new Date()) < 30) {
          alert("Your License will expire after " + differenceInDays(new Date(accessorToken.CurrentUser.LicenseEndDate), new Date()) + ". Please communicate with EthioB2B for renewal.");
        }
        seterrMsg("");



        setUserName("");
        setpassword("");
        setsuccess(true);
        setGlobalToken(accessorToken.token);
        loadParent(
          accessorToken.CurrentUser.Parent,
          accessorToken.CurrentUser.Role,
          accessorToken.CurrentUser.Store,
          accessorToken.token
        );
        setGlobalUser(accessorToken.CurrentUser);

        history("/Home");
        handleClose();
      } else {
        if (response.status == 402) {
          seterrMsg("No Server Response");
        } else if (response?.status === 401) {
          seterrMsg("Username and Password is Incorrect");
        } else if (response?.status === 404) {
          seterrMsg("Unauthorize");
        } else if (response?.status === 400) {
          seterrMsg("This user is inactive");
        } else if (response?.status === 403) {
          seterrMsg("The company is inactive");
        } else {
          seterrMsg("Login Faild");
        }
      }
    } catch (err) {
      sessionStorage.setItem("accessorToken", "");
      if (!err?.response) {
        seterrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        seterrMsg("No Server Response");
      } else if (err.response?.status === 401) {
        seterrMsg("Username and Password is Incorrect");
      } else if (err.response?.status === 404) {
        seterrMsg("There is not such user");
      } else if (err.response?.status === 403) {
        seterrMsg("The company is inactive.Please contact EthioB2B");
      } else {
        seterrMsg("Login Faild");
      }
    }
    //errRef.current.focus();
  };
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Grid container mt={1}>
      <Grid item xs={12} md={3}>
        <div>
          <div id="loginform">
            <form
              onSubmit={handleSummit}
              method="POST"
              id="myForm"
              className="row"
            >
              <h2 id="headerTitle">{t("sign in")}</h2>
              <label htmlFor="username">
                {t("Username")}:{" "}
                <input
                  type="text"
                  id="username"
                  ref={userRef}
                  autoComplete="off"
                  onChange={(e) => setUserName(e.target.value)}
                  value={userName}
                  required
                  mb={4}
                />
              </label>

              <br></br>

              <label htmlFor="password">
                {t("Password")}:{" "}
                <input
                  type="password"
                  id="password"
                  onChange={(e) => setpassword(e.target.value)}
                  required
                  value={password}
                />
              </label>
              <p
                style={{ color: "red" }}
                ref={errRef}
                className={errMsg ? "errmsg" : "uffscreen"}
                aria-live="asserive"
              >
                {errMsg}
              </p>

              <br></br>
              <button type="submit" id="button">
                {t("sign in")}
              </button>
              <Button>
                <SignupModel
                  icon={
                    <div id="button" style={{ marginTop: 5 }}>{t("sign up for testing")}</div>
                  }
                  data={{ Id: 0, Name: "" }}
                />

              </Button>

            </form>

          </div>
        </div>
      </Grid>
    </Grid>
  );
}
export default LogInModel;
